import { createSlice } from "@reduxjs/toolkit";

const INIT_STATE = {
  contentDomain: {}
};

export const ContentDomain = createSlice({
  name: "ContentDomain",
  initialState: INIT_STATE,
  reducers: {
    addContentDomain: (state, action) => {
      state.contentDomain = action.payload;
    }
  }
});
